import React from 'react';
import { createStyles } from '@mantine/core';

import SignUpStepper from './SignUpStepper';

const useStyles = createStyles(() => ({
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    width: '100%',
    gap: /* eslint-disable-line local-rules/use-theme-tokens */ '24px',
    padding: /* eslint-disable-line local-rules/use-theme-tokens */ '24px 16px',
  },
}));

interface SignUpProps {
  startFromKyc?: boolean;
}

function SignUp({ startFromKyc }: SignUpProps) {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <SignUpStepper startFromKyc={startFromKyc} />
    </div>
  );
}

export default SignUp;
